"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ignis(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.109 4.5C12.2475 5.16525 13.3185 5.9355 14.4465 6.61875L10.2885 13.872C9.7365 12.9038 9.219 11.916 8.67375 10.9425C9.459 8.78625 10.356 6.6675 11.109 4.5ZM7.5 19.5C9.85425 15.2183 12.3 10.9837 14.628 6.69075C15.2505 7.7835 15.8737 8.8755 16.5 9.96825C14.6955 13.1423 12.8775 16.3088 11.0872 19.4895C9.891 19.4895 8.69625 19.4745 7.5 19.5ZM11.3115 19.4827C12.309 17.7765 13.2487 16.0402 14.259 14.3415C14.8612 15.1117 15.4725 15.8775 16.0702 16.6515C14.4897 17.6048 12.9034 18.5485 11.3115 19.4827Z", fill: color }),
        React.createElement("path", { d: "M11.109 4.5C12.2475 5.16525 13.3185 5.9355 14.4465 6.61875L10.2885 13.872C9.7365 12.9038 9.219 11.916 8.67375 10.9425C9.459 8.78625 10.356 6.6675 11.109 4.5ZM7.5 19.5C9.85425 15.2183 12.3 10.9837 14.628 6.69075C15.2505 7.7835 15.8737 8.8755 16.5 9.96825C14.6955 13.1423 12.8775 16.3088 11.0872 19.4895C9.891 19.4895 8.69625 19.4745 7.5 19.5ZM11.3115 19.4827C12.309 17.7765 13.2487 16.0402 14.259 14.3415C14.8612 15.1117 15.4725 15.8775 16.0702 16.6515C14.4897 17.6048 12.9034 18.5485 11.3115 19.4827Z", fill: color }));
}
exports["default"] = ignis;
//# sourceMappingURL=ignis.js.map